import React, { useState } from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
import { PlusIcon, XIcon } from 'lucide-react';
interface FAQItemProps {
  question: string;
  answer: string;
  isOpen: boolean;
  onClick: () => void;
}
function FAQItem({
  question,
  answer,
  isOpen,
  onClick
}: FAQItemProps) {
  return <div className="border-b border-[#CCCCCC] py-4" data-id="element-1246">
      <button className="w-full flex items-center justify-between text-left py-2 focus:outline-none group min-h-[48px]" onClick={onClick} data-id="element-1247">
        <span className="text-black font-bold text-lg font-[Poppins,_sans-serif] pr-8 group-hover:text-[#FF1493] transition-colors" data-id="element-1248">
          {question}
        </span>
        <span className="text-[#FF1493] flex-shrink-0 transition-transform duration-300" data-id="element-1249">
          {isOpen ? <XIcon size={24} data-id="element-1250" /> : <PlusIcon size={24} data-id="element-1251" />}
        </span>
      </button>
      <div className={`overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-1252">
        <p className="text-[#333333] text-base font-body leading-[1.7] pt-4 pb-2" data-id="element-1253">
          {answer}
        </p>
      </div>
    </div>;
}
export function FinancingFAQ() {
  const [openIndex, setOpenIndex] = useState<number>(0);
  const faqs = [{
    question: 'Will Applying For Financing Impact My Credit Score?',
    answer: 'Many financing options, like Cherry and PatientFi, use a soft credit check during the application process, which does not impact your credit score. However, CareCredit may involve a hard inquiry after prequalification.'
  }, {
    question: 'How Does It Work?',
    answer: 'Patient financing allows you to split the cost of your treatment into manageable monthly payments. Depending on the provider, you can choose from a range of payment plans with terms between 3 and 24 months, often with 0% APR for qualified applicants.'
  }, {
    question: 'What Types Of Treatments Can Be Financed?',
    answer: 'Financing typically covers a wide range of medical and aesthetic treatments, including injectables, laser therapies, surgical procedures, and wellness programs. Be sure to confirm with your provider which treatments are eligible.'
  }, {
    question: 'What Are The Benefits Compared To Paying Upfront?',
    answer: 'Financing makes treatments more accessible by breaking costs into smaller, predictable payments. It allows you to start your treatment immediately, avoiding large upfront payments and managing your budget effectively.'
  }];
  return <section className="bg-[#ECECEC] py-[60px] lg:py-[100px]" data-id="element-1254">
      <div className="max-w-[800px] mx-auto px-6 lg:px-8" data-id="element-1255">
        <AnimateOnScroll className="text-center mb-12" data-id="element-1256">
          <h2 className="text-[28px] sm:text-4xl lg:text-[44px] uppercase text-black leading-tight mb-6 font-[600] font-[Poppins,_sans-serif]" data-id="element-1257">
            FREQUENTLY ASKED QUESTIONS
          </h2>
          <div className="w-[60px] h-[2px] bg-[#FF1493] mx-auto" data-id="element-1258"></div>
        </AnimateOnScroll>

        <AnimateOnScroll delay={200} data-id="element-1259">
          <div className="space-y-2" data-id="element-1260">
            {faqs.map((faq, index) => <FAQItem key={index} question={faq.question} answer={faq.answer} isOpen={openIndex === index} onClick={() => setOpenIndex(openIndex === index ? -1 : index)} data-id="element-1261" />)}
          </div>
        </AnimateOnScroll>
      </div>
    </section>;
}